import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as transferFundsFormCreateReduceObject } from '../../../common/reducers/forms/transferFundsForm';

import transferFundsFormSaga from './sagas/transferFundsFormSaga';

export default [
  // Tasks
  ...createCombineMapItem(
    'transferFundsForm',
    transferFundsFormCreateReduceObject,
    [transferFundsFormSaga]
  )
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userFlowFunds/reducers/static/forms/reducersMap.js